import classNames from 'classnames';
import { IconType } from 'react-icons';
import './TextWithIcon.scss';

interface TextWithIconProps {
    id?: string;
    className?: string;
    children: string;
    Icon: IconType;
    tooltip?: string;
}

export function TextWithIcon({ id, className, children, Icon, tooltip }: TextWithIconProps) {
    return (
        <div
            id={id}
            data-testid={id}
            className={classNames(className, 'TextWithIcon')}
            title={tooltip}
        >
            <Icon className="TextWithIcon__icon" size={20} />
            <h5 className="TextWithIcon__text">{children}</h5>
        </div>
    );
}
